export type DataPoint = {
  date: string | number;
  [key: string]: number | string | undefined;
};

export const getAxisYDomain = (
  from: string,
  to: string,
  ref: keyof DataPoint,
  offset: number,
  data: DataPoint[],
): [number, number] => {
  const fromDate = new Date(from).getTime();
  const toDate = new Date(to).getTime();

  const values = data
    .filter((d) => {
      const date = new Date(d.date).getTime();
      return date >= fromDate && date <= toDate;
    })
    .map((d) => d[ref] as number);

  if (values.length === 0) {
    return [0 - offset, 0 + offset];
  }

  const min = Math.min(...values);
  const max = Math.max(...values);

  return [min - offset, max + offset];
};
